import ReduxStore from "../redux/reduxStore.jsx";
import {Route} from "react-router-dom";
import {HomePage} from "../homePage.jsx";
import {Intro} from "../intro.jsx";
import ListView from "../listView.jsx";
import {Faq} from "../faq.jsx";
import {UserProfile} from "../userProfile.jsx";
import EvidenceCardMainContainer from "../evidenceCard.jsx";
import GreySpaceCardMainContainer from "../greySpaceCard.jsx";
import {EvidenceCardReview} from "../evidenceReview.jsx";
import {ConjectureReview} from "../conjectureReview.jsx";
import EvidenceCreationPage from "./evidenceCreation.jsx";
import {Grid} from "@material-ui/core";
import ConjectureCreation from "./conjectureCreation.jsx";
import Portfolio from "../portfolio.jsx";
import Incubator from "../incubator/incubator.jsx";
import DiscussionPage from "../discussionPage";
import {PortfolioListPage} from "../portfolioListPage.jsx";
import {IncubatorListPage} from "../incubatorListPage.jsx";
import {EditProfile} from "../editProfile.jsx";
import {Messages} from "../messages.jsx";
import {Awards} from "../awards.jsx";
import StimulusCardMainContainer from "../stimulusCard.jsx";
import {ConnectionsView} from "../connectionsView.jsx";
import {TestPageMainContainer} from "../testPage.jsx";
import PropTypes from "prop-types";

const React = require("react");
const Utils = require("../utils");
const Constants = require("../constants");
const AjaxFunctions = require("../ajaxFunctions");
const {withRouter: WithRouter} = require("react-router-dom");

class MainPageContainer extends React.Component{
   constructor(props) {
      super(props);

      let isSidebarExpanded = true;
      let showLeftBarHideButton = true;

      if(!window.globals.hasCompletedIntro){
         isSidebarExpanded = false;
         showLeftBarHideButton = false;
      }

      this.state = {
         isSidebarExpanded,
         isTopNavExpanded: false,
         showLeftBarHideButton,
         leftBarCurScreen: null,
         curDisplayPage: null,
         lastPageSet: null,
         evidenceReviewPage: 0,
         lastFilterFunction: initialCardFetch,
      };
   }

   handleUrlChange(newUrl){
      Utils.updateCurrentUserData(true);
      switch(newUrl){
         case '/': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.Home);
            return;
         }
         case '/intro': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.Intro);
            return;
         }
         case '/listView': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.ListView);
            return;
         }
         case '/faq': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.Faq);
            return;
         }
         case '/users/profile': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.UserDetails, Constants.DisplayPage.UserProfile);
            return;
         }
         case '/evidenceCard': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.Evidence);
            return;
         }

         case '/reasoningCard': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.Conjecture);
            return;
         }
         case '/evidenceReview': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.EvidenceReview);
            return;
         }
         case '/conjectureReview': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.ConjectureReview);
            return;
         }
         case '/evidenceCreation': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.EvidenceCreation);
            return;
         }
         case '/conjectureCreation': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.CreateConjecture, Constants.DisplayPage.ConjectureCreation);
            return;
         }
         case '/messages': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.PrivateMessages);
            return;
         }
         case '/portfolio': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.PortfolioManager, Constants.DisplayPage.Portfolio);
            return;
         }
         case '/incubator': {
            let incubatorId = Utils.getParameterByName('idIncubator', window.location.href);
            AjaxFunctions.createOrUpdateIncubatorView(incubatorId);
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.IncubatorPublic);
            return;
         }
         case '/discussion': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.IncubatorPublic);
         }
         case '/portfolioList': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.PortfolioList);
            return;
         }
         case '/incubatorList': { //this got moved to workshopList, it can be deleted in the future
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.IncubatorList);
            return;
         }
         case '/workshopList': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.IncubatorList);
            return;
         }
         case '/editProfile': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.UserDetails, Constants.DisplayPage.EditProfile);
            return;
         }
         case '/awards': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.Hidden, Constants.DisplayPage.Awards);
            return;
         }
         case '/connectionsView': {
            this.setLeftBarCurScreen(Constants.LeftBarScreen.ConnectionCreateConjecture, Constants.DisplayPage.ConnectionsView);
            return;
         }
         default:{
            return;
         }
      }
   }

   componentWillMount() {
      this.unlisten = this.props.history.listen((location) => {
         if(location.pathName === '/incubatorList'){
            location.pathName = 'workshopList';
         }
         gtag('config', 'UA-116205331-1', {'page_path': location.pathname});
         this.handleUrlChange(location.pathname)
      });

      this.handleUrlChange(window.location.pathname);
   };

   componentWillUnmount() {
      this.unlisten();
   }

   setLeftBarCurScreen(screen, page = -1){
      if(page === this.state.lastPageSet && page !== -1){
         if(this.state.leftBarCurScreen !== screen){
            this.setState({leftBarCurScreen: screen})
         }
         return;
      }
      if(page === -1){
         page = this.state.lastPageSet;
      }
      this.setState({lastPageSet: page}, () => {
         if(screen === this.state.leftBarCurScreen) return;

         let isSidebarExpanded = true;
         let showLeftBarHideButton = true;
         if(screen === Constants.LeftBarScreen.Hidden){
            isSidebarExpanded = false;
            showLeftBarHideButton = false;
         }
         this.setState({isSidebarExpanded, showLeftBarHideButton, leftBarCurScreen: screen, curDisplayPage: page});
      });

   }

   render() {
      if(this.state.curDisplayPage === null) return( <div /> );

      return(
         <DisplayPage
            allTopics={this.props.allTopics}
            startIntroTour={() => this.startIntroTour()}
            setLeftBarCurScreen={(screen, page) => this.setLeftBarCurScreen(screen, page)}
            evidenceReviewPage={this.state.evidenceReviewPage}
            setEvidenceReviewPage={(evidenceReviewPage) => this.setState({evidenceReviewPage})}
            latestNewsPost={this.props.latestNewsPost}
            headlines={this.props.headlines}
            amaCards={this.props.amaCards}
            lastFilterFunction={this.state.lastFilterFunction}
            setLastFilterFunction={(func) => this.setState({lastFilterFunction: func})}
            history
            hideSideBar={() => this.props.hideSidebar()}
         />
      );
   }
}

export const MainPageContainerWithRouter = WithRouter(MainPageContainer);

async function initialCardFetch(startDate, shouldAppend){
   let filterObject = Utils.buildFilterObject(startDate);
   let data = await AjaxFunctions.getFilteredCardData(filterObject);

   if (shouldAppend) ReduxStore.appendCardData(data);
   else ReduxStore.processCardData(data);

   return ReduxStore.store.getState().CardReducer.cardList;
}

class DisplayPage extends React.Component{
   constructor(props) {
      super(props);
      this.state = {
         conjectureReviewPage: 0,
      }
   }

   render(){
      return(
         <div id='displayPageContainer'>
            <Route exact path="/"
                   component={() => (
                      <HomePage
                         latestNewsPost={this.props.latestNewsPost}
                         headlines={this.props.headlines}
                         amaCards={this.props.amaCards}
                         lastFilterFunction={this.props.lastFilterFunction}
                      />
                   )}
            />

            <Route path="/intro" component={() => (  <Intro /> )} />

            <Route path="/listView"
                   render={props => (
                      <ListView
                         {...props}
                         allTopics={this.props.allTopics}
                         lastFilterFunction={this.props.lastFilterFunction}
                      />
                   )}
            />

            <Route path="/faq"  component={() => ( <Faq /> )} />
            <Route path="/users/profile" component={() => ( <UserProfile /> )} />

            <Route path="/evidenceCard"
                   component={() => (
                      <EvidenceCardMainContainer
                         allTopics={this.props.allTopics}
                      />
                   )}
            />
            <Route path="/reasoningCard"
                   component={() => (
                      <GreySpaceCardMainContainer
                         allTopics={this.props.allTopics}
                      />
                   )}
            />
            <Route path="/evidenceReview"
                   component={() => (
                      <EvidenceCardReview
                         allTopics={this.props.allTopics}
                         curPage={this.props.evidenceReviewPage}
                         setEvidenceReviewPage={(page) => this.props.setEvidenceReviewPage(page)}
                      />
                   )}
            />
            <Route path="/conjectureReview"
                   component={() => (
                      <ConjectureReview
                         allTopics={this.props.allTopics}
                         curPage={this.state.conjectureReviewPage}
                         setConjectureReviewPage={(conjectureReviewPage) => this.setState({conjectureReviewPage})}
                      />
                   )}
            />
            <Route path="/evidenceCreation"
                   component={() => (
                      <EvidenceCreationPage
                         allTopics={this.props.allTopics}
                         onCreate={() => this.props.lastFilterFunction()}
                      />
                   )}
            />

            <Route path="/conjectureCreation"
                   render={() => (
                      <div className={'page-container'}>
                         <h1 className='form__header'>Create New Conjecture &#181;Pub</h1>

                         <Grid container spacing={2} >
                            <Grid item className='left-bar' lg={3}>
                               <ConjectureCreation
                                  onCancel={() => this.props.setCurScreen(LeftBarScreen.Home)}
                                  onCreate={() => this.props.lastFilterFunction()}
                               />
                            </Grid>
                            <Grid item lg={9}>
                               <ListView
                                  allTopics={this.props.allTopics}
                                  lastFilterFunction={this.props.lastFilterFunction}
                               />
                            </Grid>
                         </Grid>
                      </div>
                   )}
            />
            <Route path="/portfolio"
                   render={() =>
                      <Portfolio allTopics={this.props.allTopics} />
                   }
            />
            <Route path="/incubator"
                   render={props => (
                      <Incubator
                         {...props}
                         allTopics={this.props.allTopics}
                         showSideBar={this.props.showSideBar}
                         hideSideBar={() => this.props.hideSideBar()}
                         lastFilterFunction={this.props.lastFilterFunction}
                         setLastFilterFunction={this.props.setLastFilterFunction}
                      />
                   )}
            />

            <Route path='/discussion'
                   render={() => <DiscussionPage />}
            />

            <Route path="/portfolioList"
                   render={() => (
                      <PortfolioListPage />
                   )}
            />
            <Route path="/incubatorList"
                   component={() => (
                      <IncubatorListPage
                      />
                   )}
            />
            <Route path="/workshopList"
                   component={() => (
                      <IncubatorListPage
                      />
                   )}
            />
            <Route path="/editProfile"
                   component={() => (
                      <EditProfile
                         allTopics={this.props.allTopics}
                      />
                   )}
            />
            <Route path="/messages" component={() => (
               <Messages />
            )}
            />
            <Route path="/awards" component={() => ( <Awards /> )}/>

            <Route path="/stimulusCard" component={StimulusCardMainContainer}/>
            <Route path="/connectionsView" component={() => <ConnectionsView enableAdd={true}/>}/>
            <Route path="/altEvidence" component={TestPageMainContainer}/>
         </div>
      )
   }
}
DisplayPage.propTypes = {
   extraCSSClasses: PropTypes.string,
   setEvidenceReviewPage: PropTypes.func,
};